import st from "@/styles/DashboardMobileHeader.module.scss"
import {useAtom} from "jotai/index";
import {open_gen_dashboard_menu, unread_notif} from "@/atoms/profile.ts";
import BurgerMenuIcon from "@/svg/BurgerMenuIcon.tsx";
import Images from "@/utils/images.ts";
import {Link} from "react-router-dom";
import dashboard_class from "@/utils/dashboard_class.ts";
import {useEffect, useState} from "react";
import clsx from "clsx";
import NotificationIcon from "@/svg/NotificationIcon.tsx";
import useNotifications from "@/hooks/notifications.ts";

const DashboardMobileHeader = () => {
    
    const [, setOpenGenSideMenu] = useAtom(open_gen_dashboard_menu)
    const [showTop, setShowTop] = useState(true);
    const [unread] = useAtom(unread_notif)
    const notif = useNotifications()
    
    useEffect(() => {
        let lastScrollTop = 0;
        
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop;
            
            if (scrollTop > lastScrollTop) {
                setShowTop(false);
            } else {
                setShowTop(true);
            }
            
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        };
        
        window.addEventListener('scroll', handleScroll);
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    return (
        <div className={clsx(st.main, !showTop && st.showTop)}>
            
            <div className={st.inner}>
                <button
                    onClick={() => {
                        setOpenGenSideMenu(true)
                    }}
                    className={st.header_button}
                >
                    <BurgerMenuIcon/>
                </button>
                
                <Link to={dashboard_class.dashboard_routes.Home}>
                    <img src={Images.logos.LogoSimple} alt="logo" width={77} height={24}/>
                </Link>
                
                <button
                    onClick={() => {
                        notif.notification_sidebar_handle()
                    }}
                    className={clsx(st.header_button, st.notif_button)}
                >
                    
                    {unread ? (
                        <div className={st.badge}>
                            {unread > 9 ? "9+" : unread}
                        </div>
                    ) : null}
                    
                    <NotificationIcon/>
                </button>
            </div>
        
        </div>
    )
}

export default DashboardMobileHeader